import React from "react";
import TestimonialManager from "./child/TestimonialManager";

const TestimonialsLayer = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <TestimonialManager />
      </div>
    </div>
  );
};

export default TestimonialsLayer;
